module.exports = __webpack_public_path__ + "img/lifebloom-logo-with-name-white.051b759f.png";